import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core'
import { MenuComponent } from './menu/menu.component'
import { ClassicService, RushGameService } from '@rush-shared/services'
import { ClassicGameComponent } from './player/classic-game.component'
import { CommonModule } from '@angular/common'
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { PlayerService } from '@shared/services'
import { GameHttp } from '@core/https'
import { LiveMessagesComponent } from '@rush-shared/components'
import { LiveMessageTypeEnum } from '@rush-shared/enums'
import { LiveMessageModel } from '@rush-shared/models'
import { WebSocketService } from '@core/services'
import { filter, Subscription } from 'rxjs'

@Component({
  selector: 'app-classic',
  standalone: true,
  imports: [
    MenuComponent,
    ClassicGameComponent,
    CommonModule,
    FontAwesomeModule,
    LiveMessagesComponent,
  ],
  templateUrl: './classic.component.html',
  styleUrl: './classic.component.sass',
})
export class ClassicComponent implements OnInit, OnDestroy {
  onSeat = false

  get showGameComponent() {
    return this._classicService.showGameComponent || this.onSeat
  }

  faRightFromBracket = faRightFromBracket
  liveMessageTypeEnum = LiveMessageTypeEnum
  classicMessages: LiveMessageModel[] = []
  newMessageArrive = false

  private _subscriiption = new Subscription()

  constructor(
    private _classicService: ClassicService,
    public _playerService: PlayerService,
    private _rushGameService: RushGameService,
    private _gameHttp: GameHttp,
    private cdr: ChangeDetectorRef,
    private _webSocketService: WebSocketService,
  ) {}

  ngOnDestroy(): void {
    this._subscriiption.unsubscribe()
  }

  ngOnInit(): void {
    this._subscriiption.add(
      this._rushGameService.playerData$.observer.subscribe((playerData) => {
        if (playerData?.seat) {
          this.onSeat = true

          this._gameHttp.getPlayerMenuInitData().subscribe((i) => {
            const table = i.dealerMenuItems.find(
              (dealerMenu) => dealerMenu.dealerTableId === playerData.seat?.selectedTableId,
            )

            if (table) {
              this._classicService.setActiveTable(table)
              this._classicService.setActiveDealer(i.dealerMenuItems[0])
              this.cdr.detectChanges()
            }
          })
        }
      }),
    )

    this._subscriiption.add(this._classicService.activeDealer$.subscribe((i) => {}))

    this._subscriiption.add(
      this._classicService.initData$.definedValueObserver.subscribe((i) => {
        this.classicMessages = i.classicLiveMessages
      }),
    )
    this._webSocketService.listenToClassicMessages((messages) => {
      this.classicMessages = messages
      this.newMessageArrive = true
    })
  }

  back() {
    this._classicService.resetActiveDelear()
    this._playerService.clearCurrentSeat()
  }
}
